// extracted by mini-css-extract-plugin
export default {"main":"ModalCrearDocumento_main__x3trm","intro":"ModalCrearDocumento_intro__JCzw9","input":"ModalCrearDocumento_input__rpRrw"};